export const defaultFormShape = {
  typeDoc: "2",
  money: "PEN",
  nroDoc: "",
  capital: "",
  // sex: "M",
  cesion_comision: 0,
  ajuste_pension: "false",
  doublePaymentMonths: 0,
  defermentMonths: 0,
  plan: "PENSION CON DEV. PRIMA",
  temporalYears: 3,
  premiumRefund: 100,
  nameContractor: "",
  titlelead1: "Cotizador",
  titlelead2: "Renta Garantizada",
  subtitlelead: "Ingresa los datos para comenzar.",
  // dateBirthday: "",
  pensionPeriod: "12",
  period6months: 0.5,
};

export const portafolio = {
  name: "S&P500 Capital Protegido",
  tb: "8.00%",
  money: "USD",
  sepelio: "$5,000",
  vto: "28/03/2023",
  vtoServer: "03/28/2023",
  code: "001",
  amountS: "15000",
};

export const groupsEpi = {
  rol_asesor: "Rimac_VIDA_EPI_Asesor_Grupo",
  message_rol_invalidate:
    "Usted no tiene los privilegios para acceder a esta aplicación",
  title: "Oops!",
};

export const groups_access = {
  roles: [
    process.env.REACT_APP_ROL_ADMIN,
    process.env.REACT_APP_ROL_RENTA,
    process.env.REACT_APP_ROL_VIDA,
  ],
};

export const keyCrypto = {
  Cryptography: "R1m4c*14",
};

export const messageCacheBuster = {
  cache: "Se actualizará la página con los últimos cambios realizados",
  title: "Atención",
};

export const messageErrorValidateMoneyAndYearsVASDoll = {
  title: "La configuración de moneda $ y 1 año de temporalidad es inválido",
};
export const messageErrorValidateMoneyAndYearsVASSol = {
  title: "La configuración de moneda S/. y 1 año de temporalidad es inválido",
};

export const messageErrorValidateMoneyAndYearsVASError = {
  title:
    "La configuración de moneda $ y 2 año de temporalidad es inválido para el monto ingresado",
};

export const defaultFormShapeRI = {
  typeDoc: "2",
  nroDoc: "",
  capital: "",
  plan: "S&P500 Capital Protegido",
  // nameContractor: "",
  // dateBirthday: ""
};

export const defaultFormShapeVAS = {
  typeDoc: "2",
  nroDoc: "",
  capital: "",
  plan: "S&P500 Capital Protegido",
  money_vas: "PEN",
  dps: true,
  name_contractor_vas: "",
  first_name_vas: "",
  last_name_vas: "",
  birthday_vas: "",
  // nameContractor: "",
  // dateBirthday: ""
};
export const route = {
  BASENAME: "/",
  PATH: "/login",
  FEDERATED: "/",
  HOME: "/",
  PRODUCTS: "/productos",
  SIMULATIONS: "/simulaciones",
  QUOTES: "/cotizaciones",
  APROVATIONS: "/aprobaciones",
  CONFIG_AS: "/configuracion/AS",
  CONFIG_RV: "/configuracion/RV",
  CONFIG_RI: "/configuracion/RI",
  ASURED_DATA: "/datos-asegurado",
  CONTRATANT_DATA: "/datos-del-contratante",
  INVESTMENT_PROFILE: "/perfil-de-inversion",
  BULLETIN: "/configuracion/boletines",
  CONFIG_FACTSHEETS: "/configuracion/factsheets",
};

export const currentVersion = {
  version: "2.0.3",
};

export const user = {
  GRUPO_USUARIO_SINIESTRO: "Rimac_VIDA_EPI_Portal_Grupo",
};

export const invesment = {
  RENTA_GARANTIZADA: "RG",
  RENTA_INVERSION: "RI",
  CANAL: "web",
};

export const infoCards = [
  {
    title: "Ahorro Seguro",
    name: "ahorroSeguro",
    messages: [
      "Cobertura de vida ante fallecimiento natural y doble cobertura por fallecimiento accidental.",
      "Plazo flexible de 1 a 5 años.",
      "Prima mínima de $5,000 ó S/15,000.",
      "Tasas anuales garantizadas.",
    ],
    disabled: false,
    status: 1,
    id: 0,
    anios_max: 69,
    anios_min: 18,
  },
  {
    title: "Renta Garantizada",
    name: "rentaGarantizada",
    messages: [
      "Cobertura de vida ante fallecimiento.",
      "Plazo flexible : corto , mediano o largo plazo ( de 3 a 25 años).",
      "Prima mínima de $15,000 ó S/50,000.",
      "Rentabilidad garantizada y una renta mensual por el tiempo que tú elijas.",
    ],
    disabled: false,
    status: 1,
    id: 1,
  },
  {
    title: "Renta Inversión",
    name: "rentaInversion",
    messages: [
      "Cobertura de vida ante fallecimiento.",
      "Plazo de 3 y 5 años.",
      "Prima mínima de S/150,000.",
      "Portafolios de acuerdo a tu preferencia de riesgo.",
      "En caso de fallecimiento tus familiares tienen la opción de continuar con tu seguro.",
    ],
    disabled: false,
    status: 0,
    id: 2,
    anios_max: 90,
    anios_min: 18,
  },
  {
    title: "Inversión Global",
    name: "inversionGlobal",
    messages: [
      "Cobertura de vida ante fallecimiento.",
      "Plazo de 7 años.",
      "Prima mínima de $15,000.",
      "En caso de fallecimiento sus beneficiarios retirarán los fondos acumulados.",
    ],
    disabled: false,
    status: 1,
    id: 3,
    anios_max: 74,
    anios_min: 18,
  },
  {
    title: "Inversión Global Ultra Cash",
    name: "ultraCash",
    messages: [
      "Plazo de 1 año​",
      "Prima mínima de $5,000 o S/15,000​",
      "En caso de Fallecimiento, sus beneficiarios retirarán los fondos acumulados",
      // "La póliza se renovará automáticamente​",
    ],
    disabled: false,
    status: 1,
    id: 4,

    anios_max: 89,
    anios_min: 18,
  },
  {
    title: "Renta Vitalicia Oficiales",
    name: "rentaVitaliciaOficiales",
    messages: [
      "Cobertura de vida ante fallecimiento natural y doble cobertura por fallecimiento accidental.",
      "Plazo flexible de 1 a 5 años.",
    ],
    disabled: false,
    status: 1,
    id: 6,
    anios_max: 69,
    anios_min: 18
  },
];

export const imgBas64 = {
  logo: "data:image/png;base64,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",
};

export const cardsConfigAS = [
  {
    title: "Reglas de decisión",
    link: "MODIFICAR CSV",
    id: 0,
  },
  {
    title: "Tasas de rescate",
    link: "ACTUALIZAR TASAS",
    id: 1,
  },
];

export const cardsConfigRVO = [
  {
    title: "Carga Solicitudes",
    link: "CARGAR XML",
    type: "xml",
    id: 1,
  },
];

export const cardsUploadGanadas = [
  {
    title: "Carga Solicitudes",
    link: "CARGAR XML",
    type: "xml",
    id: 1,
  },
];

export const originLeads = [
  {
    value: "REDES_SOCIALES_PLAN_SNIPER",
    description: "Redes Sociales - Plan Sniper",
  },
  {
    value: "REFERIDOS_ASESOR",
    description: "Referidos del Asesor",
  },
  {
    value: "LEADS_PAUTA_DIGITAL_BD_RIMAC",
    description: "Leads pauta dígital/Base de datos Rímac",
  },
  {
    value: "BASE_DATOS_ASESOR",
    description: "Base de Datos del asesor",
  },
  {
    value: "OTROS",
    description: "Otros",
  },
];

export const arrayYearTime = [
  { text: "3", value: 3 },
  { text: "5", value: 5 },
  { text: "7", value: 7 },
  { text: "10", value: 10 },
  { text: "15", value: 15 },
  { text: "20", value: 20 },
  { text: "25", value: 25 },
];

export const arrayYearTimeV2 = [
  {text:"2",value: 2 },
  { text: "3", value: 3 },
  { text: "5", value: 5 },
  { text: "7", value: 7 },
  { text: "10", value: 10 },
  { text: "15", value: 15 },
  { text: "20", value: 20 },
  { text: "25", value: 25 },
];

export const arrayYearTimeRi = [
  // {text:"3",value: 3 },
  { text: "5", value: 5 },
];

export const arrayDpsRi = [
  { text: "No", value: "false" },
  { text: "Si", value: "true" },
];

export const arrayMonthDif = [
  { text: "0", value: 0, disabled: false },
  { text: "12", value: 12, disabled: false },
  { text: "24", value: 24, disabled: false },
  { text: "36", value: 36, disabled: false },
  { text: "48", value: 48, disabled: false },
  { text: "60", value: 60, disabled: false },
];

export const arrayDoublePaymentMonths = [
  { text: "0", value: 0 },
  { text: "12", value: 12 },
  { text: "24", value: 24 },
  { text: "36", value: 36 },
  { text: "48", value: 48 },
  { text: "60", value: 60 },
];

export const arrayAjusPens = [
  { text: "No", value: "false" },
  { text: "Si", value: "true" },
];

export const arrayPerioBuy = [
  { text: "Mensual", value: 12 },
  { text: "Bimestral", value: 6 },
  { text: "Trimestral", value: 4 },
  { text: "Cuatrimestral", value: 3 },
  { text: "Semestral", value: 2 },
  { text: "Anual", value: 1 },
];

export const arrayYearTempIG = [
  { text: "7", value: 7 },
  { text: "3", value: 3 },
];

export const via = [
  { value: "AL", text: "Alameda" },
  { value: "AV", text: "Avenida" },
  { value: "BJ", text: "Bajada" },
  { value: "BL", text: "Boulevard" },
  { value: "CL", text: "Calle" },
  { value: "N", text: "Callejón" },
  { value: "CA", text: "Carretera" },
  { value: "R", text: "Cooperativa" },
  { value: "E", text: "Esquina" },
  { value: "F", text: "Fundo" },
  { value: "GA", text: "Galeria" },
  { value: "H", text: "Hacienda" },
  { value: "JR", text: "Jiron" },
  { value: "KM", text: "Kilometro" },
  { value: "ML", text: "Malecon" },
  { value: "MZ", text: "Mz" },
  { value: "OT", text: "Otros" },
  { value: "OV", text: "Ovalo" },
  { value: "PQ", text: "Parque" },
  { value: "PJ", text: "Pasaje" },
  { value: "PS", text: "Paseo" },
  { value: "PL", text: "Plaza" },
  { value: "Z", text: "Plazuela" },
  { value: "PR", text: "Prolongacion" },
  { value: "Y", text: "Pueblojoven" },
  { value: "PT", text: "Puente" },
  { value: "K", text: "Tambo" },
  { value: "I", text: "Villa" },
];

export const relationships = {
  153: "Abuelo(a)",
  148: "Ahijado(a)",
  139: "Conviviente",
  135: "Conyuge",
  150: "Empleador(a)",
  151: "Entidad financiera",
  175: "Herederos Legales",
  140: "Hermano(a)",
  136: "Hijo(a)",
  138: "Madre",
  146: "Madre de hijo",
  143: "Nieto(a)",
  144: "Novio(a)",
  142: "Otros",
  137: "Padre",
  147: "Padre de hijo",
  145: "Primo(a)",
  174: "Sobrino(a)",
  141: "Tio(a)",
  134: "Titular",
  152: "Tutor",
};

export const relations = [
  { value: 153, description: "Abuelo(a)" },
  { value: 148, description: "Ahijado(a)" },
  { value: 139, description: "Conviviente" },
  { value: 135, description: "Conyuge" },
  { value: 140, description: "Hermano(a)" },
  { value: 136, description: "Hijo(a)" },
  { value: 138, description: "Madre" },
  { value: 146, description: "Madre de hijo" },
  { value: 143, description: "Nieto(a)" },
  { value: 144, description: "Novio(a)" },
  { value: 142, description: "Otros" },
  { value: 137, description: "Padre" },
  { value: 147, description: "Padre de hijo" },
  { value: 145, description: "Primo(a)" },
  { value: 174, description: "Sobrino(a)" },
  { value: 141, description: "Tio(a)" },
  { value: 134, description: "Titular" },
  { value: 152, description: "Tutor" },
];

export const sideActionsRV = {
  DETALLE_MODALIDAD: "DETALLE_MODALIDAD",
  MEJORAR_MODALIDAD: "MEJORAR_MODALIDAD",
  RECALCULAR_MODALIDAD: "RECALCULAR_MODALIDAD",
  ACTUALIZAR_ASEGURADO: "ACTUALIZAR_ASEGURADO",
  ACTUALIZAR_BENEFICIARIO: "ACTUALIZAR_BENEFICIARIO",
};
export const weftType = {
  aprovations: "APROVATIONS",
  quotes: "QUOTES",
  simulations: "SIMULATIONS"
}

export const planListRG = {
  PLAN_PENSION_FAMILIAR: 'PLAN_PENSION_FAMILIAR',
  PLAN_CON_DEVOLUCION_DE_PRIMA:'PLAN_CON_DEVOLUCION_DE_PRIMA',
  PLAN_CON_DEVOLUCION_INTEGRAL: 'PLAN_CON_DEVOLUCION_INTEGRAL',
  PLAN_CON_PENSION_MAXIMA: 'PLAN_CON_PENSION_MAXIMA',
  PLAN_CON_DEVOLUCION_EN_VIDA: 'PLAN_CON_DEVOLUCION_EN_VIDA',
  PLAN_PENSION_PERMANENTE: 'PLAN_PENSION_PERMANENTE'
}

export const typeDocumentListAsContractors = [
  {
    name : 'DNI',
    value: '2',
    min: 8,
  },
  {
    name: 'CE',
    value: '1',
    min: 9
  },
  {
    name: 'RUC',
    value: '4',
    min: 11
  },
  {
    name: 'PASAPORTE',
    value: '3',
    min: 8
  },
];

export const typeDocumentListAsInsured = [
  {
    name : 'DNI',
    value: '2',
    min: 8,
  },
  {
    name: 'CE',
    value: '1',
    min: 8
  },
  {
    name: 'PASAPORTE',
    value: '3',
    min: 8
  },
];

export const getAllDocumentTypes = [
  ...typeDocumentListAsContractors
]

export const clientsType = {
  CONTRACTORS: 'contratante',
  INSURED: 'asegurado'
}
export const plansValues = {
  PLAN_PENSION_FAMILIAR: "Plan pensión familiar",
  PLAN_CON_DEVOLUCION_DE_PRIMA: "Plan con devolución de prima",
  PLAN_CON_DEVOLUCION_INTEGRAL: "Plan con devolución integral",
  PLAN_CON_PENSION_MAXIMA: "Plan con pensión máxima",
  PLAN_CON_DEVOLUCION_EN_VIDA: "Plan con devolución en vida",
  PLAN_PENSION_PERMANENTE: "Plan pensión permanente"
}

export const VALOR_OPORTUNIDAD = 'OPORTUNIDAD';

export const defaultPhoneNumber = "999999999";

export const moneyType = {
  USD: 'USD',
  PEN: 'PEN',
}

export const temporalYearByMoneyType = {
  USD: 3,
  PEN: 2,
}

export const profileTypes = {
  RENTA: 'renta',
  ADMIN: 'admin',
}

export const afpFinrisk = {
  1010: 'AFP HABITAT',
  1004: 'AFP Horizonte',
  1002: 'AFP Integra',
  1009: 'Prima AFP',
  1001: 'Profuturo AFP' 
}

export const conditionInvalidate = {
  'S': 'SI',
  'N': 'NO'
}

export const relationshipsKeys = {
  CY: 'CY',
  HI: 'HI',
  PA: 'PA',
  CB: 'CB',
}

export const familyRelationship = {
  [relationshipsKeys.CY]: 'Cónyuge', 
  [relationshipsKeys.HI]: 'Hijo', 
  [relationshipsKeys.PA]: 'Padres', 
  [relationshipsKeys.CB]: 'Concubino'
}

export const beneficiaryType = {
  'A': 'Jubilación',
  'B': 'Jubilación Anticipada',
  'D': 'Sobrevivencia',
  'C': 'Invalidez',
  'F': 'Jubilación Anticipada por riesgo Regimen Extraor',
  'G': 'Jubilación Anticipada por riesgo Genérico',
  'H': 'Jubilación Anticipada Reg. Especial desempleados',
  'I': 'Jubilación Adelantada Ley Nro 19990'
}

export const benefiType = {
  'J': 'Jubilación',
  'S': 'Sobrevivencia',
  'IT': 'Invalidez Total',
  'IP': 'Invalidez Parcial'
}

export const typeCurrency = {
  'S/.AJ.': 'Soles ajustados',
  'S/.': 'Soles nominales',
  'US$AJ.': 'Dólares ajustados',
  'US$': 'Dólares nominales'
}

export const foundType = {
  9: 'Fondo de Protección de Capital',
  1: 'Fondo de Mantenimiento de Capital',
  2: 'Fondo de Balanceado o Mixto',
  3: 'Fondo de Crecimiento'
}

export const documentTypeList = {
  '00': 'DNI',
  '01': 'CE',
  '04': 'Pasaporte'
}

export const genderKeys = {
  F: 'F',
  M: 'M'
}

export const genderList = {
  [genderKeys.F]: 'Femenino', 
  [genderKeys.M]: 'Masculino'
}

export const stateOfSurvival = {
  'A': 'Sano (Estado Sobrevivencia)',
  'T': 'Inv.Total (Grado de invalidez) ',
  'P': 'Inv. Parcial (Grado de invalidez) '
}

export const EESScobertura = {
  '4151': 'INVITA SEGUROS DE VIDA',
  '4150': 'MAPFRE PERU VIDA CIA. DE SEGUROS',
  '4140': 'INTERSEGURO CIA. DE SEGUROS',
  '4120': 'EL PACIFICO VIDA CIA. DE SEGUROS',
  '4153': 'LA POSITIVA VIDA SEGUROS',
  '4040': 'RIMAC INTERNACIONAL CIA. DE SEGUROS'
}

export const haveCoverage = {
  'S': 'SI',
  'N': 'NO'
}

export const typeMoneyDescription = {
  'S/.': 'Soles',
  'S/.Aj.': 'Soles Ajustados',
  'US$Aj.': 'Dolares Ajustados'
}

export const MODALITIES = {
  RENTA_VITALICIA: 'RV',
  RENTA_TEMPORAL_VITALICIA_DIFERIDA: 'RTVD',
  RENTA_VITALICIA_ESCALONADA: 'RVE',
}

export const bankList = {
  BCP_DOLARES: 'BCP DOLARES',
  BCP_SOLES: 'BCP SOLES',
  CAJA: 'CAJA',
  BBVA: 'BBVA BANCO CONTINENTAL',
  INTERBANK: 'INTERBANK',
  BANCO_DE_LA_NACION: 'BANCO DE LA NACIÓN',
  ONP: 'ONP',
  SCOTIABANK: 'SCOTIABANK',
  PROVINCIA: 'PROVINCIA',
  BANCO_DE_COMERCIO: 'BANCO DE COMERCIO',
  BANBIF: 'BANCO INTERAMERICANO DE FINANZAS (BANBIF)',
  BANCO_PICHINCHA: 'BANCO PICHINCHA (BANCO FINANCIERO)',
  CITIBANK: 'CITIBANK DEL PERU',
  MI_BANCO: 'MI BANCO',
  BANCO_GNB: 'BANCO GNB PERU',
  FALABELLA: 'BANCO FALABELLA',
  BANCO_RIPLEY: 'BANCO RIPLEY',
  BANCO_SANTANDER: 'BANCO SANTANDER PERU',
  BANCO_AZTECA: 'BANCO AZTECA',
  BANCO_CENCOSUD: 'BANCO CENCOSUD',
  BCP: 'BCP - BANCO DE CREDITO DEL PERU',
  HSBC: 'HSBC',
  BANK_OF_AMERICA: 'BANK OF AMERICA',
  CHEQUE_DNI: 'CHEQUE DNI',
  CHEQUE_AGENCIA: 'CHEQUE AGENCIA',
  PAGO_AL_EXTERIOR: 'PAGO AL EXTERIOR',
}

export const accountPrefix = {
  BBVA: '0011'
}

export const accountTypeList = {
  SAVING: 'Ahorros',
  CURRENT: 'Cuenta corriente',
  MASTER: 'Cuenta maestra',
}

export const inputKey = {
  ACCOUNT_TYPE: '709d777a-f4d0-4007-8a17-1cbf404318e8',
  SELECTED_BANK: 'd8b06964-71d7-4e88-a6a2-96b89a55cca4',
  ACCOUNT_NUMBER: '81c78c84-aa79-4c70-b1ea-79c813a6b920',
  SELECTED_CURRENCY: '9cd20160-6b9a-4fec-91ec-cb7fa9de9689'
}

export const indicatorTypeAccount = {
  CURRENT: '01',
  SAVING: '02',
}

export const indicatorTypeCurrency = {
  PEN: 'Soles',
  USD: 'Dólares',
}

export const typeValueCurrency = {
  PEN: "0",
  USD: "1",
}

export const typeModalRV = {
  DETAIL: 'DETALLE_MODALIDAD',
  IMPROVE: 'MEJORAR_MODALIDAD',
  RECALCULATE: 'RECALCULAR_MODALIDAD',
  UPDATE_INSURED: 'ACTUALIZAR_ASEGURADO',
  UPDATE_BENEFICIARY: 'ACTUALIZAR_BENEFICIARIO',
}

export const typeCurrencyValues = {
  'soles-ajustados': 'S/.AJ.',
  'soles-nominales': 'S/.',
  'dolares-ajustados': 'US$AJ.',
  'dolares-nominales': 'US$'
}

export const USERS_ROLE = {
  admin: "Administrador",
  adminfull: "Administrador",
  renta: "Renta",
  rentarrvv: "Renta",
  vida: "Vida",
  suscriptor: "Suscriptor",
  broker: "Broker",
  emisor: "Emisor",
  emisorrrvv: "Emisor",
};

export const productDictionary = {
  IG: { code: "IG", name: "Inversión global" },
  UC: { code: "UC", name: "Inversión Global Ultra Cash" },
  RG: { code: "RG", name: "Renta garantizada" },
  RV: { code: "RV", name: "Renta Vitalicia" },
  RVEO: { code: "RV", name: "Renta Vitalicia" },
  AS: { code: "AS", name: "Ahorro Seguro" },
  RI: { code: "RI", name: "Renta Inversión" }
}

export const productCardListDictionary = {
  "inversionGlobal": "IG",
  "ultraCash": "UC",
  "rentaGarantizada": "RG",
  "rentaVitalicia": "RV",
  "rentaVitaliciaOficiales": "RV",
  "ahorroSeguro": "AS",
  "rentaInversion": "RI",
}